module.exports = __webpack_public_path__ + "static/media/11.38daca98.jpg";